import React, { useEffect, useRef } from 'react';
import './AnimationTest.css'; // Import your CSS file

const SpriteAnimation = () => {
  const spriteRef = useRef();

  useEffect(() => {
    const totalSprites = 9;
    let currentSprite = 0;

    const animateSprite = () => {
      if (spriteRef.current) {

        spriteRef.current.style.backgroundPosition =
        `-${currentSprite * spriteRef.current.offsetWidth}px 0px`;
      currentSprite = (currentSprite + 1) % totalSprites;
      
        /*spriteRef.current.style.backgroundPosition =
          `-${currentSprite * spriteRef.current.offsetWidth}px 0px`;
        currentSprite = (currentSprite + 1) % totalSprites; */
      }
    };

    const intervalId = setInterval(animateSprite, 1000 / totalSprites);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="background-container">
      <div className="centered-image" ref={spriteRef}></div>
    </div>
  );
};

export default SpriteAnimation;